import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { IntlProvider, addLocaleData } from 'react-intl';
import * as en from 'react-intl/locale-data/en';
import * as ru from 'react-intl/locale-data/ru';
import * as uk from 'react-intl/locale-data/uk';
import * as moment from 'moment';
import './styles.css';
import 'leaflet/dist/leaflet.css';

import App from './components/App';

require('moment/locale/ru');
require('moment/locale/uk');
require('polyline-encoded');

// Our translated strings
import * as localeData from './translations/data.json';
addLocaleData([...en, ...ru, ...uk]);

const ORDER_VIEW_LANG = 'Order.View.Lang';

interface IndexState {
  lang: string;
  messages: { [key: string]: string };
}

class IndexComp extends React.Component<{}, IndexState> {

  constructor(props: {}) {

    super(props);

    let nav: any = navigator;// tslint:disable-line
    const language = (nav.languages && nav.languages[0]) ||
      nav.language ||
      nav.userLanguage;
    // Split locales with a region code
    const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
    let storageLang = localStorage.getItem(ORDER_VIEW_LANG);
    let lang = storageLang || languageWithoutRegionCode || language || 'en';
    this.state = {
      lang: lang,
      messages: localeData[lang]
    };
    moment.locale(this.state.lang);
    this.onLangChange = this.onLangChange.bind(this);
  }

  render() {
    return (
      <IntlProvider locale={this.state.lang} messages={this.state.messages}>
        <App onLangChange={this.onLangChange} lang={this.state.lang}/>
      </IntlProvider>
    );
  }

  private onLangChange(lang: string) {

    localStorage.setItem(ORDER_VIEW_LANG, lang);
    this.setState ({
      lang: lang,
      messages: localeData[lang]
    });
    moment.locale(lang);
  }
}

// Render our root component into the div with id "root"
// We select the messages to pass to IntlProvider based on the user's locale
ReactDOM.render(
  <IndexComp />,
  document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// /opt/build/sharedorder/node_modules/tslint-loader!./src/index.tsx